import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import React from 'react'
import Alert from 'src/components/alert'
import { RegisterCustomerStatus } from 'src/graphql/generated/graphql-types'
import LoginLink from 'src/loginLink'

type Props = {
    status: RegisterCustomerStatus | null
    email: string
    returnUrl: string | null
}

const Error = ({ status, email, returnUrl }: Props) => {

    const { translate } = useTranslations()

    if (status) {

        switch (status) {
            case RegisterCustomerStatus.UsernameAlreadyExists:
            case RegisterCustomerStatus.UsernameAlreadyRegisteredOnSite:
                return <LoginLink
                    titleTranslationKey="Register_UsernameAlreadyExists_Title"
                    bodyTranslationKey="Register_UsernameAlreadyExists_Login"
                    email={email}
                    returnUrl={returnUrl}
                />
            case RegisterCustomerStatus.OrganizationNumberAlreadyExists:
                return <Alert variant="danger">
                    <p>{translate('Register_Error')}</p>
                    <p>{translate('Register_Error_OrganizationNumberAlreadyExists')}</p>
                </Alert>
            case RegisterCustomerStatus.DisallowNewContact:
                return <Alert variant="danger">
                    <p>{translate('Register_Error')}</p>
                    <p>{translate('Register_Error_DisallowNewContact')}</p>
                </Alert>
            case RegisterCustomerStatus.PreRegistrationEmailDomainInvalid:
                return <Alert variant="danger">
                    <p>{translate('Register_PreRegistrationEmailDomainInvalid')}</p>
                </Alert>
            default:
                break;
        }
    }

    return <></>
}

export default Error